import React, { useState, useCallback } from 'react';
import { useDemo } from '../context/DemoContext';
import UnifiedChatView from './UnifiedChatView';

const MainTabbedView: React.FC = () => {
  const { state, startDemo, pauseDemo, resetDemo } = useDemo();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = useCallback(() => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  }, [isMobileSidebarOpen]);

  return (
    <div className="fullscreen-demo">
      {/* Single Header with All Info */}
      <div className="demo-header">
        <div className="header-left">
          <button 
            className="mobile-sidebar-toggle"
            onClick={toggleMobileSidebar}
            aria-label="Toggle sidebar"
          >
            ☰
          </button>
          <div className="header-title">
            <img src="/Aisberg-Symbol-Square-Small.png" alt="Aisberg" className="header-logo" />
            <h2 className="text-lg">
              <span className="desktop-title">Aisberg Artificial Mind Demo</span>
              <span className="mobile-title">Aisberg Demo</span>
            </h2>
          </div>
        </div>
        
        {/* Demo Controls in Header */}
        <div className="demo-controls">
          <button
            onClick={state.isComplete ? resetDemo : (state.isAutoPlaying ? pauseDemo : startDemo)}
            className={`btn ${
              state.isComplete ? 'btn-secondary' : (state.isAutoPlaying ? 'btn-warning' : 'btn-primary')
            }`}
          >
            <span className="desktop-label">
              {state.isComplete ? '🔄 Restart' : (state.isAutoPlaying ? '⏸️ Pause' : (state.currentStep === 0 ? '▶️ Start Demo' : '▶️ Resume'))}
            </span>
            <span className="mobile-label">
              {state.isComplete ? '🔄' : (state.isAutoPlaying ? '⏸️ Pause' : (state.currentStep === 0 ? '▶️ Start' : '▶️ Resume'))}
            </span>
          </button>
          {!state.isComplete && (
            <button
              onClick={resetDemo}
              className="btn"
            >
              <span className="desktop-label">🔄 Reset</span>
              <span className="mobile-label">🔄</span>
            </button>
          )}
        </div>
      </div>

      {/* Chat Interface directly in grid */}
      <UnifiedChatView 
        isMobileSidebarOpen={isMobileSidebarOpen}
        setIsMobileSidebarOpen={setIsMobileSidebarOpen}
      />
    </div>
  );
};

export default MainTabbedView;